import React, { useContext, useState, useEffect } from "react";
import { object, func, bool, string } from "prop-types";
import { PortraitModalComponent } from "styled_components/Common/PortraitModalComponent";
import { TicketApi } from "services/ticket";
import { AddUserDataContext } from "context/AddUserContext";
import { ModalFooter } from "styled_components/Common/ModalFooter";
import { ModalHeader } from "styled_components/Common/ModalHeader";
import { Utils } from "services/utils";
import { UserProfileApi } from "services/userProfile";
import { AvatarApi } from "services/avatar";
import { BloxButton } from "styled_components/Common/BloxButton";
import { ConfirmationScreen } from "styled_components/Common/ConfirmationScreen";
import { useActiveScreen } from "hooks/useActiveScreen";
import { DCAccessScreen } from "./Screens/DCAccessScreen";
import { BadgeScreen } from "./Screens/BadgeScreen";
import { ReviewScreen } from "./Screens/ReviewScreen";

const SCREENS = {
  0: DCAccessScreen,
  1: BadgeScreen,
  2: ReviewScreen,
  3: ConfirmationScreen,
};
const SUBTITLE = {
  0: "DATA CENTER ACCESS",
  1: "BADGE ACCESS",
  2: "Review Request",
  3: "Confirmed",
};
const TITLE = {
  0: "Please select the Data centers they will need access to.",
  1: "Will your user need a badge ? ",
  2: "Please review all details and submit your request.",
  3: "Your request has been submitted. Click the ticket number below to see your ticket.",
};

function getHeader(index) {
  const avatarApi = new AvatarApi();
  return (
    <ModalHeader image={avatarApi.getGenericAvatar()} text={TITLE[index]} />
  );
}
function checkValidation(activePage, inputs) {
  let valid = false;

  switch (activePage) {
    case 0:
      const locationsArray = inputs?.locations;
      if (locationsArray && locationsArray.length !== 0) {
        valid = true;
      }
      break;
    case 1:
      if (inputs.badgeAccess !== "") {
        valid = true;
      }
      break;
    case 2:
      if (!inputs.submitted) {
        valid = true;
      }
      break;
    default:
  }
  return valid;
}

function getButtonText(inputs, activePage) {
  let text = "NEXT";

  switch (activePage) {
    case 0:
      if (inputs.badgeAccess !== "") {
        text = "REVIEW";
      }
      break;
    case 1:
      if (inputs.badgeAccess !== "") {
        text = "REVIEW";
      }
      break;
    case 2:
      text = "SUBMIT";
      break;
    default:
  }
  return text;
}
function getButtonFunction(
  buttonText,
  activePage,
  setActivePageIndex,
  id,
  setModalContent,
  refreshUsers,
  currentUserId,
  inputs,
  setCaseId,
  change,
  rosterUser,
  loggedInUserId,
  ticketType,
  setTicketId,
  auth_status
) {
  const locations = inputs?.locations;

  if (activePage === 0 || activePage === 1) {
    if (buttonText === "REVIEW") {
      return () => setActivePageIndex(2);
    } else if (activePage === 1 && locations.includes("No Access")) {
      return () => setActivePageIndex(activePage + 2);
    } else {
      return () => setActivePageIndex(activePage + 1);
    }
  } else if (activePage === 2) {
    return () => {
      change({ target: { name: "submitted", value: true } });

      submitDataCenterUser(
        setModalContent,
        id,
        refreshUsers,
        currentUserId,
        inputs,
        setCaseId,
        change,
        setActivePageIndex,
        rosterUser,
        loggedInUserId,
        ticketType,
        setTicketId,

        auth_status
      );
    };
  }
}

function getLocationTag(location) {
  let tag = "";
  if (location === "Chattanooga" || location === "CHA") {
    tag = "CHA";
  }
  if (location === "Birmingham" || location === "BHM") {
    tag = "BHM";
  }
  if (location === "Atlanta" || location === "ATTL") {
    tag = "ATL";
  }
  if (location === "Huntsville" || location === "HSV") {
    tag = "HSV";
  }
  if (location === "Greenville" || location === "GSP") {
    tag = "GSP";
  }
  if (location === "Myrtle Beach" || location === "MYR") {
    tag = "MYR";
  }

  return tag;
}

function formatLocations(org_id, locations, rosterUser) {
  const datacenters = [];

  locations.map((location) => {
    datacenters.push({
      rosteruser_id: rosterUser?.id,
      organization_id: org_id,
      datacenter: getLocationTag(location),
      vendor: true,
      guest: false,
      escort_required: true,
      status: 1,
    });
  });
  return datacenters;
}

async function submitDataCenterUser(
  setModalContent,
  id,
  refreshUsers,
  currentUserId,
  inputs,
  setCaseId,
  change,
  setActivePageIndex,
  rosterUser,
  loggedInUserId,
  ticketType
) {
  const locationIds = formatLocations(id, inputs?.locations, rosterUser);
  const successfulCalls = [];

  for (const location of locationIds) {
    const currentLocation = Utils.getLocationNameByTag(location.datacenter);
    const params = {
      firstname: inputs?.firstname.trim(),
      lastname: inputs?.lastname.trim(),
      isActive: false,
      userId: currentUserId,
      emailAddress: inputs?.email?.toLowerCase(),
      organizationId: id,
      datacenters: [location],
      badgeRequired: inputs?.badgeAccess.includes("Yes"),
      positionTitle: "",
      createdBy: loggedInUserId,
    };

    const errorMessage =
      "Oops , " + `${currentLocation}` + " datacenter must be at lunch.";
    const button = (
      <BloxButton
        className="buttons41"
        id="okay"
        text="OKAY"
        module="account"
        enabled={true}
        onClick={() => {}}
        cypressId="okay"
      />
    );

    try {
      const response = await TicketApi.addNewRosterUser(params);
      const validResponse = response.status === 200 && response.data;

      if (validResponse) {
        successfulCalls.push(location);
        if (ticketType?.bonita) {
          setCaseId(response.data.caseId);
        }
      } else {
        setModalContent("TIMEOUT_CLOSE", errorMessage, button);
      }
    } catch (e) {
      console.log("error", e);
      setModalContent("TIMEOUT_CLOSE", errorMessage, button);
    }
  }

  if (successfulCalls.length === locationIds.length) {
    refreshUsers(id);
    setActivePageIndex(3);
  } else {
    change({ target: { name: "submitted", value: false } });
  }
}

function getButtonFunction2(activePage, setActivePageIndex, inputs) {
  const locations = inputs?.locations;

  if (activePage === 3 && locations.includes("No Access")) {
    return () => setActivePageIndex(activePage - 2);
  } else if (setActivePageIndex && activePage !== 0 && activePage !== 3) {
    return () => setActivePageIndex(activePage - 1);
  } else {
    return null;
  }
}

export const BadgeAddRequest = ({
  closeModal,
  breakpoint,
  showModal,
  id,
  setModalContent,
  refreshUsers,
  currentUserId,
  navigate,
  rosterUser,
  user,
  loggedInUserId,
  setTicketId,
  auth_status,
}) => {
  const { activePageIndex, setActivePageIndex } = useActiveScreen(0);
  const [caseId, setCaseId] = useState(null);
  const [companyServices, setCompanyServices] = useState([]);
  const { inputs, change } = useContext(AddUserDataContext);
  const [ticketType, setTicketType] = useState(null);
  const Screen = SCREENS[activePageIndex];

  const buttonText = getButtonText(inputs, activePageIndex);

  useEffect(() => {
    if (rosterUser) {
      change({
        target: { name: "hasLocations", value: rosterUser?.datacenterList },
      });
    } else {
      change({ target: { name: "hasLocations", value: [] } });
    }

    if (user) {
      change({ target: { name: "firstname", value: user?.firstname } });
      change({ target: { name: "lastname", value: user?.lastname } });
      change({
        target: { name: "email", value: user?.userProfile?.emailAddress },
      });
    }
  }, [rosterUser]);

  useEffect(() => {
    getCompanyServices(id);
    getTicketType("add-roster-user");
  }, [id]);

  function getTicketType(type) {
    TicketApi.getTicketType(type)
      .then((response) => {
        if (response.status === 200 && response?.data && !response.data.error) {
          setTicketType(response?.data);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }

  async function getCompanyServices(id) {
    const { organizationServices } =
      await new UserProfileApi().getCompanyServices(id);

    setCompanyServices(organizationServices);
  }

  function resetModal() {
    change({ target: { name: "firstname", value: "" } });
    change({ target: { name: "lastname", value: "" } });
    change({ target: { name: "email", value: "" } });
    change({ target: { name: "locations", value: [] } });
    change({ target: { name: "badgeAccess", value: "" } });
    change({ target: { name: "hasLocations", value: [] } });
    change({ target: { name: "submitted", value: false } });

    closeModal();
    setActivePageIndex(0);
  }
  return (
    <div
      className="add-user-request-component-wrapper"
      id="issue-request-component-wrapper"
    >
      <PortraitModalComponent
        closeModal={resetModal}
        show={showModal}
        header={getHeader(activePageIndex)}
        title="ADD ACCESS REQUEST"
        subTitle={SUBTITLE[activePageIndex]}
        size={"medium"}
        breakpoint={breakpoint}
      >
        <Screen
          setActivePageIndex={setActivePageIndex}
          caseId={caseId}
          resetModal={resetModal}
          navigate={navigate}
          type="BADGE_REQUEST"
          rosterUser={rosterUser}
          organizationServices={companyServices}
        />
        <ModalFooter
          cypressId="footer"
          id="footer"
          buttonText1={buttonText}
          buttonText2="Back"
          buttonActive1={checkValidation(activePageIndex, inputs)}
          buttonActive2={!inputs?.submitted}
          module="account"
          buttonFunction1={getButtonFunction(
            buttonText,
            activePageIndex,
            setActivePageIndex,
            id,
            setModalContent,
            refreshUsers,
            currentUserId,
            inputs,
            setCaseId,
            change,
            rosterUser,
            loggedInUserId,
            ticketType,
            setTicketId,

            auth_status
          )}
          size={"medium"}
          buttonFunction2={getButtonFunction2(
            activePageIndex,
            setActivePageIndex,
            inputs
          )}
        />
      </PortraitModalComponent>
    </div>
  );
};

BadgeAddRequest.propTypes = {
  closeModal: func.isRequired,
  breakpoint: string.isRequired,
  showModal: bool.isRequired,
  id: string,
  setModalContent: func.isRequired,
  refreshUsers: func,
  currentUserId: string.isRequired,
  rosterUser: object.isRequired,
  user: object.isRequired,
};

BadgeAddRequest.defaultProps = {
  refreshUsers: () => {},
  id: "",
};
